var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyPalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5997 6.90015H8.29966C7.52646 6.90015 6.89966 7.52695 6.89966 8.30015V14.6002C6.89966 15.3734 7.52646 16.0002 8.29966 16.0002H14.5997C15.3729 16.0002 15.9997 15.3734 15.9997 14.6002V8.30015C15.9997 7.52695 15.3729 6.90015 14.5997 6.90015Z",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1 11.1002H3.4C3.0287 11.1002 2.6726 10.9527 2.41005 10.6902C2.1475 10.4276 2 10.0715 2 9.70022V3.40024C2 3.02894 2.1475 2.67284 2.41005 2.41029C2.6726 2.14774 3.0287 2.00024 3.4 2.00024H9.7C10.0713 2.00024 10.4274 2.14774 10.6899 2.41029C10.9525 2.67284 11.1 3.02894 11.1 3.40024V4.10024",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyPalette);
export default __webpack_public_path__ + "static/media/copyPalette.ecc6d9c596139b212ba464010a0557c2.svg";
export { ForwardRef as ReactComponent };